export const STATUS_PENDENTE = 0
export const STATUS_EXCLUIDO = 1

export const StatusTitle = function (s) {
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s].titulo
}

export const Status = {
  0: {titulo: 'Dívida Ativa', class: 'danger'},
  1: {titulo: 'Excluído', class: 'success'}
}



// WEBPACK FOOTER //
// ./src/domain/inadimplentes/helpers/ArrematanteStatus.js